
import React from "react";
import NavBar from "./NavBar";
import Experience from "./Experience";
import Skills from "./Skills";
import Footer from "./Footer";
import About from "./About";
import Contact from "./Contact";
import NavSticky from "./NavSticky";
import Project from "./Project";

function Home(){
    return (
    <div>
         <NavBar/>
         <NavSticky/>
         <About/>
         <Skills/>
         <Experience/> 
         <Project/>      
         <Contact/>
         <Footer/>
    </div>
);}

export default Home;